module.exports = __webpack_public_path__ + "static/media/ad4.560b0ba0.png";